import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-navy text-white relative border-t border-navy-light" data-id="element-120">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <FadeIn data-id="element-122">
          <div className="flex items-center justify-center mb-6" data-id="element-123">
            <AlertTriangle className="w-12 h-12 text-red-500 mb-4" data-id="element-124" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-125">
            El sistema de crédito en USA está diseñado para que{' '}
            <span className="text-red-400" data-id="element-126">pierdas</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-127">
          <FadeIn delay={0.2} data-id="element-128">
            <div className="bg-navy-light p-8 rounded-xl border border-red-900/30 h-full" data-id="element-129">
              <h3 className="text-xl font-bold text-gold mb-4 font-serif" data-id="element-130">
                El Negocio del Riesgo
              </h3>
              <p className="text-gray-300 font-sans leading-relaxed" data-id="element-131">
                Los burós de crédito (Experian, Equifax y TransUnion) son
                empresas privadas que ganan dinero cuando tú pareces un
                "riesgo", porque eso permite que los bancos te cobren intereses
                abusivos del 24% o más.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-132">
            <div className="bg-navy-light p-8 rounded-xl border border-red-900/30 h-full" data-id="element-133">
              <h3 className="text-xl font-bold text-gold mb-4 font-serif" data-id="element-134">
                El Robo Silencioso
              </h3>
              <p className="text-gray-300 font-sans leading-relaxed" data-id="element-135">
                Si tienes una colección de hace 3 años o un error en un pago
                médico, ese número te perseguirá en cada decisión importante de
                tu vida, robándote miles de dólares en ahorros que deberían ser
                para tus hijos o tu retiro.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}